export default __webpack_public_path__ + "static/media/pizza-gif.b2ce2780.gif";